var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 681,
    viewBox: "0 0 415 681",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.005,
    cy: 29.3259,
    rx: 17.7881,
    ry: 16.1863,
    fill: "#FFDBA3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.005 1V10.442",
    stroke: "#F9BF63",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.005 49.5581V59.0001",
    stroke: "#F9BF63",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1357 30H78.5121",
    stroke: "#F9BF63",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.499 30H131.876",
    stroke: "#F9BF63",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4697 50.5063L84.8069 43.8299",
    stroke: "#F9BF63",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.204 16.1704L122.541 9.49392",
    stroke: "#F9BF63",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.542 50.5063L115.205 43.8299",
    stroke: "#F9BF63",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8076 16.1709L77.4704 9.4944",
    stroke: "#F9BF63",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.492 162.711C142.492 162.711 141.838 159.094 139.889 158.669C138.747 158.471 137.571 158.605 136.506 159.055C135.928 157.723 134.999 156.567 133.813 155.705C130.127 153.153 127.957 157.832 127.957 157.832C127.957 157.832 125.571 152.091 120.368 149.339C118.468 148.308 116.297 147.855 114.132 148.04C111.968 148.225 109.909 149.039 108.22 150.378C106.251 152.08 104.75 155.268 104.534 156.33C104.317 157.391 103.447 154.844 100.411 155.481C97.3745 156.118 95.6418 160.159 95.6418 160.159C95.6418 160.159 94.1217 158.229 92.1685 159.094C90.2152 159.958 89.5655 162.07 89.5655 162.07L81.3232 164H147.261L142.492 162.711Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M307.577 219.599C306.525 218.704 305.44 217.831 304.321 216.98C281.029 199.373 250.102 190.16 219.945 186.416C189.382 182.644 156.965 186.061 130.629 200.879C127.706 202.527 124.869 204.303 122.117 206.206C100.197 221.433 89.7187 242.773 86.844 266.711C84.6457 285.017 74.2241 299.349 67.0654 316.258C59.2743 334.683 59.3682 357.306 69.6395 375.011C91.4438 391.3 105.753 380.678 134.371 384.373C183.128 383.449 205.386 383.449 256.793 384.373C286.471 378.369 318.269 400.999 329.135 357.066C339.506 334.268 339.995 308.671 336.6 284.629C333.3 261.248 327.644 236.726 307.577 219.599Z",
    fill: "url(#paint0_linear_4745_16444)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M347.863 64.3715C347.863 64.3715 347.498 62.5616 346.404 62.35C345.756 62.2513 345.089 62.3205 344.486 62.549C344.162 61.8775 343.635 61.2939 342.961 60.8592C340.871 59.5958 339.642 61.9236 339.642 61.9236C339.642 61.9236 338.275 59.0494 335.317 57.6628C334.238 57.1496 333.006 56.9263 331.78 57.0214C330.554 57.1165 329.388 57.5256 328.431 58.1966C327.462 59.0263 326.744 60.0505 326.341 61.1782C326.221 61.7088 325.729 60.4328 324.007 60.7518C322.286 61.0708 321.305 63.0923 321.305 63.0923C321.305 63.0923 320.444 62.1447 319.335 62.5616C318.643 62.8745 318.119 63.4096 317.876 64.0524L313.204 65H350.569L347.863 64.3715Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M294.774 250.29C294.602 253.301 294.23 256.3 293.661 259.271C292.755 263.741 293.889 264.02 296.135 264.897C298.381 265.774 302.95 263.518 304.536 260.779C306.121 258.039 307.112 252.409 307.112 252.409L294.774 250.29Z",
    fill: "#62C6E9",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M304.436 257.398C303.942 259.365 302.677 262.448 299.13 263.495C298.14 263.79 297.081 263.838 296.064 263.633C295.047 263.428 294.109 262.978 293.348 262.33C293.526 263.962 294.551 264.285 296.109 264.893C298.363 265.765 302.924 263.514 304.51 260.775C306.095 258.035 307.112 252.409 307.112 252.409L305.668 252.178C305.335 253.619 304.767 256.072 304.436 257.398Z",
    fill: "#DEDEDE",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M282.801 252.724C285.974 253.038 289.181 252.912 292.312 252.349C297.93 251.428 304.632 248.361 304.126 244.223C303.619 240.085 296.955 237.898 294.19 237.733C292.184 237.641 290.175 237.659 288.172 237.788C288.172 237.788 286.661 248.958 282.801 252.724Z",
    fill: "#62C6E9",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M279.94 253.917C282.212 253.788 284.378 252.996 286.118 251.659C288.705 249.505 290.262 245.6 289.658 242.722C289.055 239.843 279.94 253.917 279.94 253.917Z",
    fill: "#62C6E9",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M264.144 224.761C264.144 224.761 260.399 233.271 262.697 242.562C264.995 251.853 273.337 255.305 279.914 253.912C286.492 252.52 289.474 244.914 290.548 239.718C291.621 234.521 291.913 232.12 291.913 232.12C291.913 232.12 270.999 230.647 264.144 224.761Z",
    fill: "#F49600",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M263.863 222.214C263.863 222.214 262.388 224.972 264.026 226.334C265.664 227.696 274.201 234.313 285.868 234.175C292.398 234.099 291.332 232.191 291.401 231.248C291.471 230.306 263.863 222.214 263.863 222.214Z",
    fill: "#62C6E9",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M264.086 212.866C264.086 212.866 262.979 220.062 263.863 222.214C264.748 224.367 280.309 232.998 289.12 232.687C297.931 232.376 313.078 227.718 315.708 222.929C318.338 218.139 315.536 209.484 312.16 205.001C308.784 200.517 307.125 199.468 307.125 199.468C307.125 199.468 294.669 210.078 281.313 212.114C267.956 214.149 264.086 212.866 264.086 212.866Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M327.21 241.622C327.21 241.622 336.706 239.878 339.878 242.385C343.05 244.892 344.882 249.869 345.396 257.137C345.91 264.404 339.463 268.672 334.788 267.758C330.112 266.844 331.474 264.19 330.191 261.062C328.908 257.935 326.976 255.918 326.884 255.6C326.793 255.281 330.776 246.676 327.21 241.622Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M339.878 242.385C338.823 241.69 337.575 241.28 336.276 241.2C337.848 242.667 340.816 246.222 342.049 252.226C343.776 260.539 341.506 264.396 339.568 265.652C337.629 266.908 334.041 266.891 332.564 266.49L331.74 266.261C332.274 266.954 333.169 267.468 334.783 267.781C339.459 268.696 345.901 264.451 345.392 257.16C344.882 249.869 343.05 244.892 339.878 242.385Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M304.59 258.462C304.59 258.462 312.544 261.991 320.87 260.394C329.196 258.796 334.694 254.807 334.095 248.771C333.496 242.735 330.303 242.022 323.215 240.951C316.127 239.881 314.588 240.247 314.588 240.247C314.588 240.247 311.242 256.444 304.59 258.462Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M319.142 232.369C321.45 224.738 317.045 216.98 309.303 215.04C301.56 213.101 293.412 217.715 291.104 225.347C288.795 232.978 293.201 240.736 300.943 242.675C308.685 244.615 316.833 240 319.142 232.369Z",
    fill: "#F49600",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M319.015 249.171C321.109 242.247 317.115 235.208 310.094 233.449C303.073 231.69 295.683 235.878 293.588 242.802C291.494 249.726 295.488 256.765 302.509 258.524C309.53 260.282 316.92 256.095 319.015 249.171Z",
    fill: "#F49600",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M318.854 240.481C318.854 240.481 321.644 229.183 316.744 221.922C311.843 214.661 296.936 217.565 292.806 226.584C288.675 235.603 290.849 250.461 296.508 255.117C302.167 259.772 308.274 257.09 312.881 252.636C317.489 248.182 318.854 240.481 318.854 240.481Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M238.612 194.693C238.612 194.693 231.703 204.584 229.916 207.432C228.13 210.279 226.22 213.52 225.871 215.492C225.522 217.465 226.368 220.194 227.394 220.45C228.419 220.705 229.3 220.185 229.702 218.87C230.104 217.556 230.154 216.987 231.033 216.375C232.235 215.673 233.508 215.078 234.835 214.598C235.157 214.522 235.187 215.572 234.273 216.567C233.36 217.562 231.631 218.318 232.351 219.599C233.07 220.881 235.262 219.872 236.456 219.08C237.901 218.09 239.044 216.78 239.777 215.276C240.516 213.7 240.981 210.197 240.981 210.197L250.965 204.213C250.965 204.213 239.921 201.165 238.612 194.693Z",
    fill: "url(#paint1_linear_4745_16444)",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M235.077 215.761C235.077 215.761 234.653 217.26 237.76 217.832",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M227.087 213.179C227.194 214.064 227.658 214.882 228.389 215.473C229.121 216.064 230.068 216.386 231.046 216.378",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M226.01 217.222C226.01 217.222 227.838 219.052 229.756 217.695",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M233.235 203.289C233.235 203.289 231.823 209.093 241.039 210.208",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M241.646 191.919C241.646 191.919 239.361 191.589 238.612 194.694C237.864 197.799 239.662 203.056 244.802 204.707C249.942 206.357 253.768 204.007 255.183 201.805C256.597 199.602 245.62 190.632 241.646 191.919Z",
    fill: "#62C6E9",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M249.224 184.364C249.224 184.364 242.446 189.581 240.865 192.54C239.283 195.5 240.615 201.611 246.683 203.295C252.752 204.979 257.35 200.882 257.35 200.882L249.224 184.364Z",
    fill: "url(#paint2_linear_4745_16444)",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M253.38 179.935C250.479 181.634 248.394 184.271 247.545 187.314C246.298 192.264 250.234 198.824 256.93 199.333C263.626 199.843 258.85 180.57 253.38 179.935Z",
    fill: "#62C6E9",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M255.421 184.077C255.421 184.077 251.86 186.816 252.496 192.487C252.891 195.904 254.366 199.143 256.743 201.812C256.743 201.812 262.8 213.716 265.885 215.912C268.971 218.107 274.986 219.133 288.068 216.586C301.151 214.039 307.248 208.202 309.776 205.109C312.304 202.017 304.35 184.645 301.014 181.778C297.732 179.104 293.58 177.478 289.189 177.147C286.81 177.026 284.424 177.049 282.047 177.216L255.421 184.077Z",
    fill: "#F49600",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M253.59 181.956C253.59 181.956 250.035 184.695 250.671 190.367C251.065 193.786 252.54 197.027 254.917 199.697C254.917 199.697 260.974 211.602 264.058 213.803C267.143 216.005 273.159 217.025 286.241 214.478C299.324 211.93 305.414 206.093 307.949 203.001C310.484 199.909 302.523 182.537 299.168 179.666C295.884 176.991 291.73 175.365 287.337 175.035C284.959 174.914 282.575 174.938 280.201 175.105L253.59 181.956Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M284.089 180.589C288.606 172.123 284.726 161.927 275.422 157.816C266.118 153.706 254.914 157.236 250.396 165.702C245.878 174.169 249.758 184.364 259.062 188.475C268.366 192.586 279.571 189.056 284.089 180.589Z",
    fill: "#F49600",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M279.512 182.707C288.227 175.632 288.988 163.468 281.213 155.539C273.438 147.609 260.07 146.916 251.356 153.991C242.641 161.066 241.88 173.23 249.655 181.16C257.43 189.089 270.798 189.782 279.512 182.707Z",
    fill: "#FDF6EA",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M279.203 173.329C279.655 172.763 279.932 172.096 280.004 171.399C280.15 169.958 278.904 167.05 278.337 166.224C277.77 165.398 276.454 166.055 276.454 166.055L275.57 163.727C274.387 161.231 272.211 159.235 269.477 158.139C266.744 157.043 263.657 156.928 260.835 157.818C258.012 158.707 255.664 160.535 254.261 162.934C252.858 165.333 252.504 168.127 253.27 170.753L255.1 175.572L254.027 173.116C254.027 173.116 252.572 173.32 252.668 174.307C252.764 175.294 253.761 178.279 254.859 179.329C255.421 179.875 256.148 180.258 256.948 180.43L259.328 186.782C260.857 187.192 262.431 187.444 264.022 187.535C267.413 187.75 270.812 187.215 273.928 185.978C277.044 184.741 279.785 182.836 281.919 180.428L279.203 173.329Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M274.779 167.158C274.396 166.151 273.799 165.222 273.022 164.425C272.245 163.627 271.303 162.977 270.249 162.512C269.196 162.046 268.052 161.774 266.883 161.71C265.713 161.647 264.542 161.794 263.436 162.143L261.693 162.696C260.587 163.044 259.567 163.587 258.692 164.294C257.816 165.001 257.103 165.858 256.592 166.816C256.08 167.774 255.782 168.815 255.713 169.878C255.644 170.941 255.806 172.006 256.19 173.013L261.615 187.282C262.416 187.417 263.225 187.508 264.038 187.555C267.05 187.739 270.071 187.332 272.894 186.359C275.718 185.387 278.278 183.873 280.402 181.92L274.779 167.158Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M263.485 173.461C263.689 173.991 263.567 174.518 263.212 174.631C262.856 174.744 262.402 174.398 262.199 173.862C261.996 173.325 262.117 172.804 262.473 172.691C262.829 172.578 263.282 172.924 263.485 173.461Z",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M270.715 171.183C270.918 171.72 270.795 172.247 270.434 172.353C270.074 172.459 269.631 172.126 269.422 171.583C269.214 171.039 269.348 170.52 269.702 170.413C270.057 170.306 270.512 170.646 270.715 171.183Z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M267.332 171.454L269.969 175.825L266.644 176.621",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M270.994 179.251C271.067 179.442 271.076 179.649 271.021 179.845C270.965 180.041 270.846 180.218 270.68 180.352C270.514 180.487 270.308 180.574 270.087 180.602C269.867 180.63 269.642 180.597 269.442 180.509C269.242 180.421 269.075 180.28 268.962 180.105C268.85 179.93 268.797 179.729 268.811 179.527C268.824 179.325 268.903 179.131 269.038 178.97C269.172 178.808 269.357 178.687 269.567 178.621C269.848 178.534 270.156 178.55 270.423 178.668C270.69 178.786 270.896 178.996 270.994 179.251V179.251Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M259.042 172.037C259.042 172.037 259.89 170.242 262.673 170.524",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M267.341 168.893C267.341 168.893 268.444 167.023 271.208 168.055",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M266.206 185.012C267.405 185.539 268.701 185.859 270.029 185.954C271.428 185.966 272.79 185.541 273.886 184.751C274.632 184.141 275.895 181.963 275.895 181.963",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M247.991 176.848C248.275 172.85 249.923 169.032 252.705 165.927C255.488 162.822 259.266 160.585 263.513 159.528C267.76 158.47 272.263 158.646 276.395 160.029C280.527 161.413 284.082 163.935 286.563 167.245C286.379 164.281 285.445 161.397 283.832 158.816C282.22 156.236 279.973 154.03 277.268 152.371C274.563 150.713 271.473 149.646 268.24 149.254C265.007 148.862 261.717 149.157 258.63 150.114C255.542 151.071 252.74 152.665 250.442 154.772C248.144 156.879 246.413 159.44 245.383 162.257C244.354 165.074 244.055 168.069 244.509 171.008C244.964 173.947 246.159 176.751 248.002 179.2C247.947 178.417 247.943 177.631 247.991 176.848V176.848Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M295.513 195.98C300.758 196.297 305.329 192.183 305.723 186.79C306.117 181.397 302.184 176.769 296.938 176.452C291.693 176.135 287.122 180.249 286.728 185.642C286.335 191.035 290.268 195.663 295.513 195.98Z",
    fill: "#62C6E9",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M319.277 182.084C315.111 180.474 310.766 179.278 306.318 178.517C298.171 177.021 293.221 176.974 290.95 180.424C288.68 183.874 287.874 189.928 292.535 192.71C295.136 194.269 299.389 194.296 302.522 194.149C305.654 194.001 313.541 192.394 316.536 189.406C319.532 186.419 320.071 183.772 319.277 182.084Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M326.748 189.102C326.748 189.102 324.901 184.232 320.078 182.189C315.254 180.146 310.064 182.404 307.396 185.013C304.728 187.622 305.473 188.737 305.473 188.737C305.473 188.737 313.519 186.548 317.466 186.538C321.413 186.527 326.748 189.102 326.748 189.102Z",
    fill: "#62C6E9",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M304.725 191.697C304.725 191.697 304.135 188.407 309.705 185.152C315.275 181.898 323.799 184.754 326.107 187.894C328.416 191.034 327.193 195.727 324.477 197.648C322.989 198.757 321.238 199.538 319.363 199.931C319.363 199.931 316.24 192.311 304.725 191.697Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M299.552 197.14C299.552 197.14 302.242 193.041 304.727 191.69C307.211 190.34 313.791 190.655 318.304 192.927C322.816 195.2 320.991 200.106 319.786 201.535C318.582 202.963 315.586 203.782 315.586 203.782L299.552 197.14Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M300.241 196.516C299.457 196.594 298.711 196.868 298.086 197.306C296.999 198.133 295.744 198.757 294.392 199.143C292.253 199.85 290.141 199.554 290.546 201.562C290.951 203.571 293.877 203.767 295.346 203.693C296.815 203.619 297.491 203.235 298.726 202.644C299.962 202.053 301.841 196.906 301.89 196.653C301.939 196.399 300.241 196.516 300.241 196.516Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M305.725 195.598C305.725 195.598 302.959 194.51 301.338 195.332C299.717 196.153 299.06 200.201 298.691 202.687C298.323 205.173 298.908 207.289 299.889 207.738C300.268 207.952 300.699 208.077 301.144 208.104C301.589 208.131 302.035 208.058 302.442 207.893C302.928 207.588 303.209 203.934 304.046 201.062C304.883 198.19 305.725 195.598 305.725 195.598Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M305.725 195.598C304.557 197.325 303.621 199.173 302.936 201.103C301.99 203.988 302.969 208.202 303.575 208.658C304.181 209.113 306.118 209.315 306.707 208.51C307.297 207.706 307.563 204.712 307.951 202.988C308.338 201.265 309.972 197.689 310.058 196.524C310.143 195.359 307.346 194.777 305.725 195.598Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M310.058 196.524C310.058 196.524 311.931 196.053 313.061 196.872C314.19 197.691 314.151 199.477 313.825 200.263C313.5 201.048 311.935 205.99 311.297 207.145C310.659 208.3 309.537 208.685 308.726 208.494C307.915 208.303 307.532 207.252 307.608 206.171C307.684 205.09 307.946 203.012 307.946 203.012L310.058 196.524Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M314.123 198.695C315.119 199.075 316.068 199.551 316.952 200.115C317.554 200.655 317.546 202.075 316.665 204.108C315.784 206.141 314.874 207.252 313.779 207.186C312.684 207.12 312.055 205.749 312.199 205.007C312.343 204.265 313.992 200.436 314.123 198.695Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M283.091 195.356C284.133 197.734 283.093 200.343 280.774 201.185C278.455 202.028 275.725 200.788 274.688 198.387C273.652 195.985 274.68 193.399 277.006 192.558C279.331 191.716 282.043 192.983 283.091 195.356Z",
    fill: "#62C6E9",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M274.88 205.309C275.613 206.969 274.871 208.799 273.261 209.391C271.651 209.983 269.725 209.11 268.967 207.439C268.21 205.769 268.976 203.948 270.586 203.356C272.196 202.764 274.148 203.642 274.88 205.309Z",
    fill: "#F49600",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M123.863 238.789H244.815L197.573 348.182H71.8169L123.863 238.789Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M258.979 285.48H332.78L303.954 352.184H227.222L258.979 285.48Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M96.089 358.301H97.8555V384.019H96.089V358.301Z",
    fill: "#1D1D1B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M172.046 358.301H170.28V384.019H172.046V358.301Z",
    fill: "#1D1D1B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M131.963 233.176H252.905L193.19 357.777H72.2471L131.963 233.176Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M187.336 307.769L197.813 285.841H224.638L214.161 307.769H187.336Z",
    fill: "#FFFBF5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M212.829 310.563L202.353 332.502H175.528L186.005 310.563H212.829Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M157.499 307.769L167.976 285.841H194.801L184.324 307.769H157.499Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M182.992 310.563L172.503 332.502H145.679L156.168 310.563H182.992Z",
    fill: "#FFFBF5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M199.145 283.048L209.621 261.12H236.458L225.969 283.048H199.145Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M210.953 258.328L221.442 236.389H248.266L237.777 258.328H210.953Z",
    fill: "#FFFBF5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M110.415 283.048L120.892 261.12H146.934L136.457 283.048H110.415Z",
    fill: "#FFFBF5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5947 307.769L109.084 285.841H135.126L124.637 307.769H98.5947Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7858 332.502L97.2626 310.563H123.317L112.828 332.502H86.7858Z",
    fill: "#FFFBF5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M122.223 258.328L132.7 236.389H158.755L148.266 258.328H122.223Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M164.54 355.493L174.197 335.283H201.021L191.364 355.493H164.54Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7977 355.493L85.4548 335.283H111.497L101.84 355.493H75.7977Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M139.47 283.048L149.947 261.12H176.772L166.295 283.048H139.47Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M127.661 307.769L138.138 285.841H164.963L154.486 307.769H127.661Z",
    fill: "#FFFBF5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M134.701 355.493L144.347 335.283H171.183L161.526 355.493H134.701Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M181.115 258.328L191.604 236.389H218.428L207.939 258.328H181.115Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M153.155 310.563L142.666 332.502H115.841L126.33 310.563H153.155Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M104.865 355.493L114.51 335.283H141.335L131.69 355.493H104.865Z",
    fill: "#FFFBF5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M169.307 283.048L179.784 261.12H206.608L196.132 283.048H169.307Z",
    fill: "#FFFBF5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M151.278 258.328L161.767 236.389H188.592L178.103 258.328H151.278Z",
    fill: "#FFFBF5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M349.22 385.679H39.5627L44.8441 384.552H343.939L349.22 385.679Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M230.262 365.867H231.519V384.164H230.262V365.867Z",
    fill: "#1D1D1B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M284.3 365.867H283.043V384.164H284.3V365.867Z",
    fill: "#1D1D1B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M255.829 276.92H341.713L299.298 365.423H213.414L255.829 276.92Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M295.293 329.844L302.677 314.388H321.601L314.217 329.844H295.293Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M313.201 331.977L305.816 347.441H286.892L294.277 331.977H313.201Z",
    fill: "#E5F4F9",
    stroke: "black",
    strokeWidth: 0.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M274.065 329.844L281.45 314.388H300.374L292.99 329.844H274.065Z",
    fill: "#E5F4F9",
    stroke: "black",
    strokeWidth: 0.5
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M291.973 331.977L284.58 347.441H265.656L273.049 331.977H291.973Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M303.694 312.257L311.079 296.801H330.011L322.618 312.257H303.694Z",
    fill: "#E5F4F9",
    stroke: "black",
    strokeWidth: 0.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M312.095 294.67L319.488 279.206H338.412L331.019 294.67H312.095Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M240.568 312.257L247.952 296.801H266.32L258.935 312.257H240.568Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M232.158 329.844L239.552 314.388H257.919L250.526 329.844H232.158Z",
    fill: "#E5F4F9",
    stroke: "black",
    strokeWidth: 0.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M223.757 347.441L231.141 331.977H249.518L242.124 347.441H223.757Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M248.969 294.67L256.353 279.206H274.73L267.337 294.67H248.969Z",
    fill: "#E5F4F9",
    stroke: "black",
    strokeWidth: 0.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M279.075 363.798L285.876 349.564H304.8L297.999 363.798H279.075Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M215.94 363.798L222.741 349.564H241.109L234.308 363.798H215.94Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M261.239 312.257L268.623 296.801H287.548L280.163 312.257H261.239Z",
    fill: "#E5F4F9",
    stroke: "black",
    strokeWidth: 0.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M252.838 329.844L260.222 314.388H279.147L271.762 329.844H252.838Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M257.847 363.798L264.64 349.564H283.573L276.771 363.798H257.847Z",
    fill: "#E5F4F9",
    stroke: "black",
    strokeWidth: 0.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M290.867 294.67L298.261 279.206H317.185L309.792 294.67H290.867Z",
    fill: "#E5F4F9",
    stroke: "black",
    strokeWidth: 0.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M270.746 331.977L263.352 347.441H244.428L251.821 331.977H270.746Z",
    fill: "#E5F4F9",
    stroke: "black",
    strokeWidth: 0.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M236.619 363.798L243.413 349.564H262.337L255.544 363.798H236.619Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M282.466 312.257L289.851 296.801H308.775L301.391 312.257H282.466Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M269.64 294.67L277.034 279.206H295.958L288.565 294.67H269.64Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M112.682 491H125.39V486.644H112.682V491ZM112.682 470.156H125.39V465.8H112.682V470.156ZM112.682 479.768H124.67V475.484H112.682V479.768ZM109.37 465.8V491H114.338V465.8H109.37ZM136.187 479.264L143.747 491H149.831L141.623 479.264H136.187ZM130.463 465.8V491H135.611V465.8H130.463ZM133.595 470.192H138.599C139.511 470.192 140.291 470.348 140.939 470.66C141.611 470.948 142.127 471.38 142.487 471.956C142.847 472.508 143.027 473.18 143.027 473.972C143.027 474.764 142.847 475.448 142.487 476.024C142.127 476.576 141.611 477.008 140.939 477.32C140.291 477.608 139.511 477.752 138.599 477.752H133.595V481.856H138.923C140.915 481.856 142.607 481.52 143.999 480.848C145.391 480.176 146.459 479.24 147.203 478.04C147.947 476.816 148.319 475.412 148.319 473.828C148.319 472.22 147.947 470.816 147.203 469.616C146.459 468.416 145.391 467.48 143.999 466.808C142.607 466.136 140.915 465.8 138.923 465.8H133.595V470.192ZM158.512 479.264L166.072 491H172.156L163.948 479.264H158.512ZM152.788 465.8V491H157.936V465.8H152.788ZM155.92 470.192H160.924C161.836 470.192 162.616 470.348 163.264 470.66C163.936 470.948 164.452 471.38 164.812 471.956C165.172 472.508 165.352 473.18 165.352 473.972C165.352 474.764 165.172 475.448 164.812 476.024C164.452 476.576 163.936 477.008 163.264 477.32C162.616 477.608 161.836 477.752 160.924 477.752H155.92V481.856H161.248C163.24 481.856 164.932 481.52 166.324 480.848C167.716 480.176 168.784 479.24 169.528 478.04C170.272 476.816 170.644 475.412 170.644 473.828C170.644 472.22 170.272 470.816 169.528 469.616C168.784 468.416 167.716 467.48 166.324 466.808C164.932 466.136 163.24 465.8 161.248 465.8H155.92V470.192ZM179.108 478.4C179.108 476.792 179.444 475.364 180.116 474.116C180.788 472.868 181.712 471.884 182.888 471.164C184.064 470.444 185.432 470.084 186.992 470.084C188.576 470.084 189.956 470.444 191.132 471.164C192.308 471.884 193.22 472.868 193.868 474.116C194.516 475.364 194.84 476.792 194.84 478.4C194.84 480.008 194.504 481.436 193.832 482.684C193.184 483.932 192.272 484.916 191.096 485.636C189.92 486.356 188.552 486.716 186.992 486.716C185.432 486.716 184.064 486.356 182.888 485.636C181.712 484.916 180.788 483.932 180.116 482.684C179.444 481.436 179.108 480.008 179.108 478.4ZM173.672 478.4C173.672 480.296 173.996 482.06 174.644 483.692C175.292 485.3 176.216 486.704 177.416 487.904C178.616 489.104 180.02 490.04 181.628 490.712C183.26 491.36 185.048 491.684 186.992 491.684C188.936 491.684 190.712 491.36 192.32 490.712C193.952 490.04 195.356 489.104 196.532 487.904C197.732 486.704 198.656 485.3 199.304 483.692C199.976 482.06 200.312 480.296 200.312 478.4C200.312 476.48 199.976 474.728 199.304 473.144C198.656 471.536 197.72 470.144 196.496 468.968C195.296 467.792 193.892 466.892 192.284 466.268C190.676 465.62 188.912 465.296 186.992 465.296C185.096 465.296 183.332 465.62 181.7 466.268C180.092 466.892 178.688 467.792 177.488 468.968C176.288 470.144 175.352 471.536 174.68 473.144C174.008 474.728 173.672 476.48 173.672 478.4ZM210.016 479.264L217.576 491H223.66L215.452 479.264H210.016ZM204.292 465.8V491H209.44V465.8H204.292ZM207.424 470.192H212.428C213.34 470.192 214.12 470.348 214.768 470.66C215.44 470.948 215.956 471.38 216.316 471.956C216.676 472.508 216.856 473.18 216.856 473.972C216.856 474.764 216.676 475.448 216.316 476.024C215.956 476.576 215.44 477.008 214.768 477.32C214.12 477.608 213.34 477.752 212.428 477.752H207.424V481.856H212.752C214.744 481.856 216.436 481.52 217.828 480.848C219.22 480.176 220.288 479.24 221.032 478.04C221.776 476.816 222.148 475.412 222.148 473.828C222.148 472.22 221.776 470.816 221.032 469.616C220.288 468.416 219.22 467.48 217.828 466.808C216.436 466.136 214.744 465.8 212.752 465.8H207.424V470.192ZM235.249 486.356H257.137V481.964H251.989L251.377 482.504H242.377L248.317 474.008V484.268L247.885 484.664V491H253.177V465.8H249.685L235.249 486.356ZM264.953 478.4C264.953 477.128 265.073 475.976 265.313 474.944C265.553 473.888 265.901 472.988 266.357 472.244C266.813 471.476 267.353 470.888 267.977 470.48C268.601 470.072 269.297 469.868 270.065 469.868C270.857 469.868 271.565 470.072 272.189 470.48C272.813 470.888 273.353 471.476 273.809 472.244C274.265 472.988 274.613 473.888 274.853 474.944C275.093 475.976 275.213 477.128 275.213 478.4C275.213 479.672 275.093 480.836 274.853 481.892C274.613 482.924 274.265 483.824 273.809 484.592C273.353 485.336 272.813 485.912 272.189 486.32C271.565 486.728 270.857 486.932 270.065 486.932C269.297 486.932 268.601 486.728 267.977 486.32C267.353 485.912 266.813 485.336 266.357 484.592C265.901 483.824 265.553 482.924 265.313 481.892C265.073 480.836 264.953 479.672 264.953 478.4ZM259.949 478.4C259.949 481.064 260.369 483.368 261.209 485.312C262.073 487.256 263.261 488.768 264.773 489.848C266.309 490.904 268.073 491.432 270.065 491.432C272.129 491.432 273.917 490.904 275.429 489.848C276.941 488.768 278.117 487.256 278.957 485.312C279.797 483.368 280.217 481.064 280.217 478.4C280.217 475.736 279.797 473.432 278.957 471.488C278.117 469.544 276.941 468.044 275.429 466.988C273.917 465.908 272.129 465.368 270.065 465.368C268.073 465.368 266.309 465.908 264.773 466.988C263.261 468.044 262.073 469.544 261.209 471.488C260.369 473.432 259.949 475.736 259.949 478.4ZM282.217 486.356H304.105V481.964H298.957L298.345 482.504H289.345L295.285 474.008V484.268L294.853 484.664V491H300.145V465.8H296.653L282.217 486.356Z",
    fill: "#6A6A6A"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M148.318 533V524.273H151.267C151.951 524.273 152.511 524.396 152.946 524.643C153.383 524.888 153.707 525.219 153.917 525.636C154.127 526.054 154.233 526.52 154.233 527.034C154.233 527.548 154.127 528.016 153.917 528.436C153.71 528.857 153.389 529.192 152.954 529.442C152.52 529.689 151.963 529.812 151.284 529.812H149.17V528.875H151.25C151.718 528.875 152.095 528.794 152.379 528.632C152.663 528.47 152.869 528.251 152.997 527.976C153.127 527.697 153.193 527.384 153.193 527.034C153.193 526.685 153.127 526.372 152.997 526.097C152.869 525.821 152.662 525.605 152.375 525.449C152.088 525.29 151.707 525.21 151.233 525.21H149.375V533H148.318ZM155.402 533H154.294L157.499 524.273H158.59L161.794 533H160.686L158.078 525.653H158.01L155.402 533ZM155.811 529.591H160.277V530.528H155.811V529.591ZM168.709 527C168.616 526.713 168.492 526.456 168.339 526.229C168.188 525.999 168.008 525.803 167.798 525.641C167.59 525.479 167.354 525.355 167.09 525.27C166.826 525.185 166.536 525.142 166.221 525.142C165.704 525.142 165.234 525.276 164.81 525.543C164.387 525.81 164.05 526.203 163.8 526.723C163.55 527.243 163.425 527.881 163.425 528.636C163.425 529.392 163.552 530.03 163.805 530.55C164.058 531.07 164.4 531.463 164.832 531.73C165.263 531.997 165.749 532.131 166.289 532.131C166.789 532.131 167.229 532.024 167.61 531.811C167.994 531.595 168.292 531.291 168.505 530.899C168.721 530.504 168.829 530.04 168.829 529.506L169.153 529.574H166.528V528.636H169.852V529.574C169.852 530.293 169.698 530.918 169.391 531.449C169.087 531.98 168.667 532.392 168.13 532.685C167.596 532.974 166.982 533.119 166.289 533.119C165.516 533.119 164.837 532.938 164.252 532.574C163.67 532.21 163.215 531.693 162.888 531.023C162.565 530.352 162.403 529.557 162.403 528.636C162.403 527.946 162.495 527.325 162.68 526.774C162.867 526.22 163.131 525.749 163.472 525.359C163.813 524.97 164.217 524.672 164.683 524.464C165.148 524.257 165.661 524.153 166.221 524.153C166.681 524.153 167.11 524.223 167.508 524.362C167.908 524.499 168.265 524.693 168.577 524.946C168.893 525.196 169.156 525.496 169.366 525.845C169.576 526.192 169.721 526.577 169.8 527H168.709ZM171.662 533V524.273H176.929V525.21H172.718V528.159H176.656V529.097H172.718V532.062H176.997V533H171.662ZM189.129 524.273V533H188.106L183.35 526.148H183.265V533H182.208V524.273H183.231L188.004 531.142H188.089V524.273H189.129ZM198.607 528.636C198.607 529.557 198.441 530.352 198.109 531.023C197.776 531.693 197.32 532.21 196.741 532.574C196.161 532.938 195.499 533.119 194.755 533.119C194.011 533.119 193.349 532.938 192.769 532.574C192.19 532.21 191.734 531.693 191.401 531.023C191.069 530.352 190.903 529.557 190.903 528.636C190.903 527.716 191.069 526.92 191.401 526.25C191.734 525.58 192.19 525.062 192.769 524.699C193.349 524.335 194.011 524.153 194.755 524.153C195.499 524.153 196.161 524.335 196.741 524.699C197.32 525.062 197.776 525.58 198.109 526.25C198.441 526.92 198.607 527.716 198.607 528.636ZM197.584 528.636C197.584 527.881 197.458 527.243 197.205 526.723C196.955 526.203 196.616 525.81 196.187 525.543C195.761 525.276 195.283 525.142 194.755 525.142C194.227 525.142 193.748 525.276 193.319 525.543C192.893 525.81 192.553 526.203 192.3 526.723C192.05 527.243 191.925 527.881 191.925 528.636C191.925 529.392 192.05 530.03 192.3 530.55C192.553 531.07 192.893 531.463 193.319 531.73C193.748 531.997 194.227 532.131 194.755 532.131C195.283 532.131 195.761 531.997 196.187 531.73C196.616 531.463 196.955 531.07 197.205 530.55C197.458 530.03 197.584 529.392 197.584 528.636ZM199.544 525.21V524.273H206.089V525.21H203.345V533H202.288V525.21H199.544ZM211.095 533V524.273H216.328V525.21H212.152V528.159H215.936V529.097H212.152V533H211.095ZM225.502 528.636C225.502 529.557 225.336 530.352 225.003 531.023C224.671 531.693 224.215 532.21 223.635 532.574C223.056 532.938 222.394 533.119 221.649 533.119C220.905 533.119 220.243 532.938 219.664 532.574C219.084 532.21 218.628 531.693 218.296 531.023C217.963 530.352 217.797 529.557 217.797 528.636C217.797 527.716 217.963 526.92 218.296 526.25C218.628 525.58 219.084 525.062 219.664 524.699C220.243 524.335 220.905 524.153 221.649 524.153C222.394 524.153 223.056 524.335 223.635 524.699C224.215 525.062 224.671 525.58 225.003 526.25C225.336 526.92 225.502 527.716 225.502 528.636ZM224.479 528.636C224.479 527.881 224.353 527.243 224.1 526.723C223.85 526.203 223.51 525.81 223.081 525.543C222.655 525.276 222.178 525.142 221.649 525.142C221.121 525.142 220.642 525.276 220.213 525.543C219.787 525.81 219.448 526.203 219.195 526.723C218.945 527.243 218.82 527.881 218.82 528.636C218.82 529.392 218.945 530.03 219.195 530.55C219.448 531.07 219.787 531.463 220.213 531.73C220.642 531.997 221.121 532.131 221.649 532.131C222.178 532.131 222.655 531.997 223.081 531.73C223.51 531.463 223.85 531.07 224.1 530.55C224.353 530.03 224.479 529.392 224.479 528.636ZM233.006 524.273H234.063V530.051C234.063 530.648 233.922 531.18 233.641 531.649C233.363 532.115 232.969 532.483 232.461 532.753C231.952 533.02 231.355 533.153 230.671 533.153C229.986 533.153 229.39 533.02 228.881 532.753C228.372 532.483 227.978 532.115 227.696 531.649C227.418 531.18 227.279 530.648 227.279 530.051V524.273H228.336V529.966C228.336 530.392 228.429 530.771 228.617 531.104C228.804 531.433 229.071 531.693 229.418 531.884C229.767 532.071 230.185 532.165 230.671 532.165C231.157 532.165 231.574 532.071 231.924 531.884C232.273 531.693 232.54 531.433 232.725 531.104C232.912 530.771 233.006 530.392 233.006 529.966V524.273ZM243.094 524.273V533H242.071L237.315 526.148H237.23V533H236.173V524.273H237.196L241.969 531.142H242.054V524.273H243.094ZM247.902 533H245.208V524.273H248.021C248.868 524.273 249.592 524.447 250.194 524.797C250.796 525.143 251.258 525.642 251.579 526.293C251.9 526.94 252.061 527.716 252.061 528.619C252.061 529.528 251.899 530.311 251.575 530.967C251.251 531.621 250.779 532.124 250.16 532.476C249.541 532.825 248.788 533 247.902 533ZM246.265 532.062H247.833C248.555 532.062 249.153 531.923 249.627 531.645C250.102 531.366 250.456 530.97 250.689 530.456C250.921 529.942 251.038 529.33 251.038 528.619C251.038 527.915 250.923 527.308 250.693 526.8C250.463 526.288 250.119 525.896 249.662 525.624C249.204 525.348 248.635 525.21 247.953 525.21H246.265V532.062Z",
    fill: "#1D1D1B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 681H97.8077L0 515V681Z",
    fill: "url(#paint3_linear_4745_16444)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M413.21 412H315.402L413.21 578V412Z",
    fill: "url(#paint4_linear_4745_16444)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M249.465 201L110.995 50L122.534 230.5L249.465 201Z",
    fill: "url(#paint5_linear_4745_16444)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4745_16444",
    x1: 201.725,
    y1: 183.615,
    x2: 201.725,
    y2: 419.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4745_16444",
    x1: 240.776,
    y1: 197.841,
    x2: 236.893,
    y2: 221.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4745_16444",
    x1: 250.98,
    y1: 186.618,
    x2: 248.247,
    y2: 203.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4745_16444",
    x1: 48.9039,
    y1: 681,
    x2: 48.9039,
    y2: 515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4745_16444",
    x1: 364.306,
    y1: 412,
    x2: 364.306,
    y2: 578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF6EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4745_16444",
    x1: 110.446,
    y1: 43.5,
    x2: 159.111,
    y2: 225.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/Error404.2e5b13ab84984ed008a2af07804d40ab.svg";
export { ForwardRef as ReactComponent };